import { SerializableObjectList } from '../../core';
import { ReportTheme } from '../other/report-theme.enum';
import { ModuleSettings } from './module-settings.do';
import { ReportPackageImport } from './report-package-import.do';


/**
 * Module settings ValueSchema: ReportModuleSettings v1.
 */
export class ReportModuleSettings extends ModuleSettings {
  /**
   * Imported report packages.
   */
  public Imports: ReportPackageImport[];

  /**
   * Flag to enable/disable showing rows with zero values.
   */
  public ShowZeroRows: boolean;
  /**
   * Reports UI Theme.
   */
  public Theme: ReportTheme;
  /**
   * Arguments set on all the imported report packages.
   */
  public Arguments: Record<string, string>;

  protected coercePropertyType(property: string, value: any): any {
    let returnValue: any = super.coercePropertyType(property, value);

    switch (property) {
      case 'Imports':
        const setsObject = new SerializableObjectList<ReportPackageImport>(ReportPackageImport, value);
        return setsObject.items;

      default:
        return returnValue;
    }
  }

}
